import { useQuery } from '@tanstack/react-query';
import { posRestaurant } from '../../../api/posAPI';
import usePosStore from '../../../stores/posStore';

export function useTables(statusFilter) {
  const { posToken } = usePosStore();

  const query = useQuery({
    queryKey: ['pos', 'tables', posToken, statusFilter],
    queryFn: async () => {
      const params = statusFilter ? { status: statusFilter } : {};
      const res = await posRestaurant.tables(posToken, params);
      return res.data.tables || [];
    },
    enabled: !!posToken,
    refetchInterval: 15_000,
    staleTime: 5_000,
  });

  return {
    tables: query.data || [],
    isLoading: query.isLoading,
    error: query.error?.response?.data?.message || query.error?.message || null,
    refetch: query.refetch,
  };
}
